import ChallengeCompleted from 'pages/loyalty/loyalty-challenge-completed';

export default function ChallengeCompletedPage() {
  return <ChallengeCompleted />;
}
